"use client";
import Image from "next/image";
import Link from "next/link";
import { useEffect } from 'react';
import { SharedFooter } from '@/components/ui/SharedFooter';

export default function Home() {
  // Animation for network nodes
  useEffect(() => {
    // This would be where we'd initialize any JavaScript animations
    // For a production app, we'd implement the network animation here
  }, []);

  return (
    <div className="min-h-screen bg-[#F9FAFB]">
      {/* Navigation Bar - White with Emerald Green logo */}
      <nav className="sticky top-0 z-50 bg-white shadow-md">
        <div className="container mx-auto px-6 py-4 max-w-7xl flex justify-between items-center">
          <div>
            <Image 
              src="/bdnog.svg" 
              alt="BDNOG Logo" 
              width={150} 
              height={45} 
              priority
            />
          </div>
          <div className="space-x-4">
            <Link href="/auth/signin" className="px-4 py-2 border border-[#10B981] text-[#10B981] rounded-md hover:bg-[#10B981] hover:text-white transition-colors font-medium">
              Sign In
            </Link>
            <Link href="/auth/signup" className="px-4 py-2 bg-[#10B981] text-white rounded-md hover:bg-[#3B82F6] transition-colors font-medium">
              Register
            </Link>
          </div>
        </div>
      </nav>
      
      {/* Hero Section with Network Animation */}
      <section className="relative min-h-[80vh] flex items-center">
        {/* Network Animation Background */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="network-animation w-full h-full opacity-20">
            {/* Using our CSS animation defined in globals.css */}
          </div>
        </div>
        
        <div className="container mx-auto px-6 max-w-7xl relative z-10">
          <div className="max-w-3xl mx-auto text-center animate-fade-in-up">
            <h1 className="text-5xl md:text-6xl font-bold text-[#111827] mb-6">
              Bangladesh Network Operators Group
            </h1>
            <p className="text-lg md:text-xl text-[#6B7280] mt-4 mb-8">
              Join the community for networking professionals in Bangladesh
            </p>
            <div className="animate-pop-in">
              <Link href="/auth/signup" className="px-8 py-4 bg-[#10B981] text-white rounded-md hover:bg-[#3B82F6] transition-colors font-medium text-lg">
                Register Now
              </Link>
            </div>
          </div>
        </div>
      </section>


      <SharedFooter />
    </div>
  );
}
